/**
 *
 */
function getSelectedText(): string | null {
  const selection = document.getSelection?.()
  return selection?.toString()?.trim() || null
}

export { getSelectedText }
